import { Tooltip as AntTooltip } from 'antd';
import styled from 'styled-components';

/** Shown on keyboard focus too, so an icon button's meaning is not limited to mouse users. */
export const Tooltip = styled(AntTooltip).attrs((props) => ({
  trigger: props.trigger ?? ['hover', 'focus'],
}))``;
